import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=5c25380b&scoped=true&"
import script from "./Client.vue?vue&type=script&lang=js&"
export * from "./Client.vue?vue&type=script&lang=js&"
import style0 from "./Client.vue?vue&type=style&index=0&id=5c25380b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c25380b",
  null
  
)

export default component.exports